<template>
  <div class="game-content-box">
    <iframe
      class="mstoreMessagePage j-mstoreMessagePage"
      src="//mstore.gm99.com/html/h5FbCanvas.html"
      v-if="isFbCanvas"
      ref="fbstoreiframe"
    ></iframe>
    <iframe :src="gameUrl" class="game-iframe" @load="gameLoaded"></iframe>
    <a
      class="aside-icon j-aside-icon"
      v-if="!isFbCanvas"
      @click="clickAsideBtn"
    ></a>
    <AsidePopup
      v-bind:class="{ show: asideState }"
      v-on:toggleAside="toggleAside"
      v-on:openAccountPopup="openAccountPopup"
      v-if="!isFbCanvas && pageInfo.asideType == 'default'"
    ></AsidePopup>
    <transition name="fade">
      <AccountComponnet
        :loginType="loginType"
        :show="!user.id"
        class="loginComponent"
        v-show="!user.id || accountState"
        v-on:hideAccountPopup="hideAccountPopup"
        v-if="!isFbCanvas"
      ></AccountComponnet>
    </transition>
    <transition name="fade">
      <PayTips
        v-on:closePayTips="closePayTips"
        :pageLink="pagePayLink"
        v-show="pagePayLink"
        :pid="productId"
      ></PayTips>
    </transition>
    <transition name="fade">
      <FBPayTips
        v-show="fbPayOrderId"
        :orderId="fbPayOrderId"
        v-on:closePayTips="closeFbPayTips"
        v-if="isFbCanvas"
        :pid="productId"
      ></FBPayTips>
    </transition>
    <transition name="fade">
      <TipPopUpComponent v-show="commonTips"></TipPopUpComponent>
    </transition>
  </div>
</template>

<script>
import AccountComponnet, { ACCOUNT_TYPE } from "./Account";
import AsidePopup from "./Aside";
import PayTips from "./PayTips";
import FBPayTips from "./FBPayTips";
import TipPopUpComponent from "./TipPopUpIframe";
import { LOAD_GAME_URL, ENTER_GAME } from "../store/gamePage";
import { GET_USER_INFO } from "../store/user";
import { judgeIsNewUser } from "../store/ga";
import { isPhone } from "../utile";
import { mapGetters, mapActions } from "vuex";
import { POPUP_STYLE } from "./TipPopUpIframe.vue";

let gameLinkSave = ""; //用于防止研发重定向、刷新的骚操作

export default {
  data() {
    return {
      loginType: ACCOUNT_TYPE.loginAccount,
      accountState: false,
      isFbCanvas: window.isFbCanvas,
      asideState: false,
      pagePayLink: "", // 儲值頁跳轉鏈接
      fbPayOrderId: false, // fb canvas 储值订单号
      productId: "" //储值目标商品
    };
  },
  watch: {
    user(newV, oldV) {
      if (newV && newV.id && oldV.id !== newV.id) {
        this[LOAD_GAME_URL]();
        this.getGiftState();
        this.asideState = false;
      }
    }
  },
  computed: {
    ...mapGetters([
      "gameUrl",
      "user",
      "roleInfo",
      "gameId",
      "commonTips",
      "pageInfo"
    ])
  },
  components: {
    AccountComponnet,
    AsidePopup,
    PayTips,
    TipPopUpComponent,
    FBPayTips
  },
  async created() {
    await this[GET_USER_INFO]({ isCheck: true });
  },
  mounted() {
    window.addEventListener("message", this.messageHandler, false);
    window.onbeforeunload = () => {
      this.gaStatistics({ eventName: "click_close_window" });
      return;
    };
  },
  methods: {
    toggleAside() {
      this.asideState = !this.asideState;
    },
    clickAsideBtn() {
      switch (this.pageInfo.asideType) {
        case "default":
          this.toggleAside();
          break;
        case "page":
          window.open(
            `//m.gm99.com/user?isH5=1&pc=${window.isPhone ? 0 : 1}&gameId=${
              this.gameId
            }&serverId=${this.roleInfo.serverId}&roleId=${
              this.roleInfo.roleId
            }&roleName=${this.roleInfo.roleName}`,
            "_blank"
          );
          break;
        case "default":
          break;
      }
    },
    openAccountPopup(type) {
      this.accountState = true;
      this.loginType = type;
    },
    hideAccountPopup() {
      this.accountState = false;
    },
    fbPay(params) {
      this.$refs.fbstoreiframe.contentWindow.postMessage(
        {
          info: {
            appId: window.appInfo.appId,
            productId: params.productId,
            paytype: "facebook_local_money",
            fpaytype: "facebook_local_money",
            gameId: this.gameId,
            serverId: params.serverId,
            roleId: params.roleId,
            roleName: params.roleName,
            roleLevel: 0,
            loginAccount: this.user.name,
            currency: "TWD",
            remark: params.price || "",
            cpOrderID: params.order_no || ""
          }
        },
        window.location.protocol + "//mstore.gm99.com"
      );
    },
    pagePay(params) {
      this.pagePayLink = `//mstore.gm99.com${
        isPhone() ? "/mobile" : ""
      }?gameId=${this.gameId}&serverId=${this.roleInfo.serverId}&roleId=${
        this.roleInfo.roleId
      }&roleName=${encodeURIComponent(this.roleInfo.roleName)}&order_no=${
        params.order_no
      }&productId=${params.productId}&productName=${params.productName}&price=${
        params.price
      }&remark=${params.remark ||
        params.order_no ||
        ""}&publishPlatForm=pc&devicePlat=pc`;
    },
    closePayTips() {
      this.pagePayLink = "";
    },
    closeFbPayTips() {
      this.fbPayOrderId = "";
    },
    gameLoaded() {
      if (this.gameUrl && this.gameUrl !== gameLinkSave) {
        gameLinkSave = this.gameUrl;
        this.gaStatistics({ eventName: "game_load" });
      }
    },
    messageHandler(evt) {
      var ev = evt || event;
      let action = ev.data.action;
      if (!!action && !!this[`sdk_${action}`]) {
        console.log(`触发：${action}`);
        console.log(ev.data.param);
        this[`sdk_${action}`](ev.data.param);
      }
    },
    sdk_enter_server(params) {
      // this.gaStatistics({ eventName: "enter_server" });
    },
    sdk_enter_create_role_page() {
      this.gaStatistics({ eventName: "enter_create_role_page" });
    },
    sdk_is_role(params) {
      this.gaStatistics({ eventName: "is_role", params });
    },
    sdk_get_role_info(params) {
      this.$store.dispatch(ENTER_GAME, params);
      this.$store.commit("updateRoleInfo", params);
      this.gaStatistics({ eventName: "enter_server_role" });
    },
    sdk_get_create_role_info(params) {
      this.$store.commit("updateRoleInfo", params);
      this.gaStatistics({ eventName: "create_role" });
    },
    sdk_pay(params) {
      this.gaStatistics({ eventName: "pay" });
      this.productId = params.productId;
      if (this.isFbCanvas) {
        this.fbPay(params);
      } else {
        this.pagePay(params);
      }
    },
    sdk_fb_share(href) {},
    sdk_select_server() {
      this[LOAD_GAME_URL]();
    },
    sdk_logout() {
      this.openAccountPopup(ACCOUNT_TYPE.switchAccount);
    },
    sdk_open_pay_list() {
      this.gaStatistics({ eventName: "open_pay_list" });
    },
    sdk_open_user_center() {
      this.asideState = true;
    },
    sdk_enter_main_game() {
      this.gaStatistics({ eventName: "enter_game" });
    },
    sdk_enter_select_server_page() {
      this.gaStatistics({ eventName: "enter_server_page" });
    },
    sdk_click_create_role_btn() {
      this.gaStatistics({ eventName: "click_create_role" });
    },
    sdk_click_enter_game_btn() {
      this.gaStatistics({ eventName: "click_enter_game" });
    },
    sdk_user_behave(params = {}) {
      console.log(params.eventName);
      // this.gaStatistics({
      //   eventName: "game_user_behave",
      //   data: params || {},
      // });
      // 绕过 上一步/账号记录 流程
      this.gaStatisticsCommon({
        eventName: "game_user_behave",
        data: {
          is_new: judgeIsNewUser(this.user.id),
          userName: this.user.name,
          ...params
        }
      });
    },
    sdk_get_order_succ(res) {
      if (0 == res.result) {
        this.$store.commit("updateCommonTips", {
          msg: res.msg,
          style: POPUP_STYLE.bad
        });
      } else {
        this.fbPayOrderId = res.data.order_id;
      }
    },
    sdk_gerOrderSuccess(res) {
      if (0 == res.result) {
        this.$store.commit("updateCommonTips", {
          msg: res.msg,
          style: POPUP_STYLE.bad
        });
      } else {
        this.fbPayOrderId = res.data.order_id;
      }
    },
    ...mapActions([
      LOAD_GAME_URL,
      GET_USER_INFO,
      "gaStatistics",
      "gaStatisticsCommon",
      "getGiftState"
    ])
  }
};
</script>

<style lang="scss">
.game-content-box,
.game-iframe {
  width: 100%;
  height: 100%;
  font-size: 0;
}

.mstoreMessagePage {
  width: 0;
  height: 0;
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/GameIframe.vue